module.exports = __webpack_public_path__ + "img/ImageOptimize-icon.svg";